import React from 'react';
import { Paper, Typography, Box, Divider } from '@mui/material';
import { useCurrency } from '../../context/CurrencyContext';

const ReportHeader = ({
  companyName,
  reportName,
  dateRange,
  asOfDate,
  currency,
  additionalInfo = []
}) => {
  const { getCurrencySymbol } = useCurrency();
  const generatedAt = new Date().toLocaleString();

  return (
    <Paper sx={{ p: 3, mb: 3 }} elevation={2}>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        {companyName && (
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {companyName}
          </Typography>
        )}
        <Typography variant="h6" color="primary" gutterBottom>
          {reportName}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
        {dateRange && (
          <Typography variant="body2" color="text.secondary">
            <strong>Period:</strong> {dateRange.start} to {dateRange.end}
          </Typography>
        )}
        
        {asOfDate && (
          <Typography variant="body2" color="text.secondary">
            <strong>As of:</strong> {asOfDate}
          </Typography>
        )}
        
        {currency && (
          <Typography variant="body2" color="text.secondary">
            <strong>Currency:</strong> {currency} ({getCurrencySymbol()})
          </Typography>
        )}
        
        {additionalInfo.map((info, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
              {info.label}:
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 800,
                color: '#163300',
                fontFamily: '"Wise Sans", "Outfit", "Inter", sans-serif'
              }}
            >
              {info.value}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Typography variant="caption" color="text.disabled">
          Generated: {generatedAt}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ReportHeader;
